// Local Deps
import { makeGraphQLRequest } from '../../../utils/requestUtils';

// export async function createRFQ(userId, solNum, rfqInput) {
//   let participants
//   let partNum
//   let niin
//   let partDesc
//   let drawingNums
//   if (rfqInput) {
//     participants = rfqInput.recipientCage || []
//     partNum = rfqInput.partNum || ""
//     niin = rfqInput.niin || ""
//     partDesc = rfqInput.partDesc || ""
//   }
//   console.log("createRFQ", userId, solNum, participants, partNum, niin, partDesc, drawingNums)
//   const query = `mutation createRFQ($userId: ID, $solNum: String, $participants: [String], $partNum: String, $niin: String, $partDesc: String, $drawingNums: String) { createRFQ (userId: $userId, solNum: $solNum, participants: $participants, partNum: $partNum, niin: $niin, partDesc: $partDesc, drawingNums: $drawingNums) { status msg rfqId  } }`;

//   // Variables
//   const variables = { userId, solNum, participants, partNum, niin, partDesc, drawingNums };

//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });
//   return response.createRFQ;
// }

export default async function getContractCenterData(id) {
  const query = `query ContractCenter(
    $id: ID
  ) {
    ContractCenter(id: $id) {

      contractData{ 
        rfq {
          drafts
          submitted
        }
      
      }
      }
    }`;

  // Variables
  const variables = { id };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response.ContractCenter.contractData;
}



// WEBPACK FOOTER //
// ./src/components/Modals/SendRfq/graphql.js